export const utmParamPairsForSimplifiedLayout = [
  { utmMedium: 'cpm', utmSource: 'facebook' },
  { utmMedium: 'ppc', utmSource: 'google' },
  { utmMedium: 'ppc', utmSource: 'yahoo' },
  { utmMedium: 'cpc', utmSource: 'yahoo' },
  { utmMedium: 'cpc', utmSource: 'bing' },
  { utmMedium: 'email', utmSource: 'zehitomo' },
  { utmMedium: 'line', utmSource: 'zehitomo' },
];
